// Full page loads go through here so tests can mock them: jsdom's Location methods can't be spied on.
export const assignLocation = (url: string) => window.location.assign(url);

export const replaceLocation = (url: string) => window.location.replace(url);
